if (!customElements.get('product-cart-upsell')) {
    customElements.define(
        'product-cart-upsell',
        class ProductCartUpsell extends HTMLElement {
            constructor() {
                super();

                this.popup = this.querySelector('.cart-upsell__popup');
                this.variants = JSON.parse(this.querySelector('[data-variants="true"]').innerText)?.variants || [];
                this.variantSelects = this.querySelectorAll('.cart-upsell__popup_option select');
                this.variantIdInput = this.querySelector('input[name="id"]');
            }

            connectedCallback() {
                this.querySelectorAll('[data-toggle-popup="true"]').forEach((toggle) => {
                    toggle.addEventListener('click', this.togglePopup.bind(this));
                });

                this.variantSelects.forEach((select) => {
                    select.addEventListener('change', this.handleVariantChange.bind(this))
                })
            }

            disconnectedCallback() {
                this.querySelectorAll('[data-toggle-popup="true"]').forEach((toggle) => {
                    toggle.removeEventListener('click', this.togglePopup.bind(this));
                });

                this.variantSelects.forEach((select) => {
                    select.removeEventListener('change', this.handleVariantChange.bind(this))
                })
            }

            togglePopup () {
                this.popup.classList.toggle('showed');
            }

            handleVariantChange() {
                const activeOptions = [];
                this.variantSelects.forEach((select) => activeOptions.push(select.value));

                const currentVariant = this.variants.find((variant) => variant.options.toString() === activeOptions.toString())

                if (!currentVariant || !this.variantIdInput) return;

                this.variantIdInput.value = currentVariant.id;
            }
        }
    );
}

if (!customElements.get('cart-with-upsell-drawer-items')) {
    customElements.define(
        'cart-with-upsell-drawer-items',
        class CartWithUpsellDrawerItems extends CartDrawerItems {
            constructor() {
                super();

                this.minCountForUpsell = parseInt(this.getAttribute('data-min-count-for-upsell-product'));
            }

            onCartUpdate(){
                if(this.tagName === 'CART-WITH-UPSELL-DRAWER-ITEMS'){
                    fetch(`${routes.cart_url}?section_id=cart-drawer`).then((response) => response.text()).then((responseText) => {
                        const html = new DOMParser().parseFromString(responseText, 'text/html');
                        const selectors = ['cart-drawer-items', '.cart-drawer__footer'];
                        for (const selector of selectors) {
                            const targetElement = document.querySelector(selector);
                            const sourceElement = html.querySelector(selector);
                            if(targetElement && sourceElement) {
                                targetElement.replaceWith(sourceElement);
                            }
                        }
                    }).catch((e) => {
                        console.error(e);
                    });
                } else {
                    fetch(`${routes.cart_url}?section_id=main-cart-items`).then((response) => response.text()).then((responseText) => {
                        const html = new DOMParser().parseFromString(responseText, 'text/html');
                        const sourceQty = html.querySelector('cart-items');
                        this.innerHTML = sourceQty.innerHTML;
                    }).catch((e) => {
                        console.error(e);
                    });
                }
            }

            updateQuantity(line, quantity, name, variantId){
                this.enableLoading(line);

                const body = JSON.stringify({
                    line,
                    quantity,
                    sections: this.getSectionsToRender().map((section) => section.section),
                    sections_url: window.location.pathname,
                });
                fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } }).then((response) => {
                    return response.text();
                }).then((state) => {
                    const parsedState = JSON.parse(state);

                    const upsellItem = parsedState.items.find((item) => item.properties._is_upsell_item);

                    const giftQty = parsedState.items.filter((item) => item.final_line_price === 0 && item.original_line_price > 0 && !(item.properties || {})._is_upsell_item).reduce((sum, item) => sum + item.quantity, 0);

                    if (upsellItem && parsedState.item_count - giftQty - 1 < this.minCountForUpsell) {
                        const upsellIndex = this.querySelector('[data-upsell-product="true"]')?.getAttribute('data-index');

                        if (upsellIndex) {
                            this.updateQuantity(upsellIndex, 0);
                            return;
                        }
                    }

                    const quantityElement =
                        document.getElementById(`Quantity-${line}`) || document.getElementById(`Drawer-quantity-${line}`);
                    const items = document.querySelectorAll('.cart-item');

                    if(parsedState.errors) {
                        quantityElement.value = quantityElement.getAttribute('value');
                        this.updateLiveRegions(line, parsedState.errors);
                        return;
                    }

                    this.classList.toggle('is-empty', parsedState.item_count === 0);
                    const cartDrawerWrapper = document.querySelector('cart-drawer');
                    const cartFooter = document.getElementById('main-cart-footer');

                    if(cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
                    if(cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);

                    this.getSectionsToRender().forEach((section) => {
                        const elementToReplace =
                            document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
                        elementToReplace.innerHTML = this.getSectionInnerHTML(
                            parsedState.sections[section.section],
                            section.selector
                        );
                    });
                    const updatedValue = parsedState.items[line - 1] ? parsedState.items[line - 1].quantity : undefined;
                    let message = '';
                    if(items.length === parsedState.items.length && updatedValue !== parseInt(quantityElement.value)) {
                        if(typeof updatedValue === 'undefined') {
                            message = window.cartStrings.error;
                        } else {
                            message = window.cartStrings.quantityError.replace('[quantity]', updatedValue);
                        }
                    }
                    this.updateLiveRegions(line, message);

                    const lineItem =
                        document.getElementById(`CartItem-${line}`) || document.getElementById(`CartDrawer-Item-${line}`);
                    if(lineItem && lineItem.querySelector(`[name="${name}"]`)) {
                        cartDrawerWrapper
                            ? trapFocus(cartDrawerWrapper, lineItem.querySelector(`[name="${name}"]`))
                            : lineItem.querySelector(`[name="${name}"]`).focus();
                    } else if(parsedState.item_count === 0 && cartDrawerWrapper) {
                        trapFocus(cartDrawerWrapper.querySelector('.drawer__inner-empty'), cartDrawerWrapper.querySelector('a'));
                    } else if(document.querySelector('.cart-item') && cartDrawerWrapper) {
                        trapFocus(cartDrawerWrapper, document.querySelector('.cart-item__name'));
                    }

                    publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', cartData: parsedState, variantId: variantId });
                })
                    .catch(() => {
                        this.querySelectorAll('.loading__spinner').forEach((overlay) => overlay.classList.add('hidden'));
                        const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
                        errors.textContent = window.cartStrings.error;
                    })
                    .finally(() => {
                        this.disableLoading(line);
                    });
            }
        }
    );
}

if (!customElements.get('cart-drawer-confetti')) {
    customElements.define(
        'cart-drawer-confetti',
        class CartDrawerConfetti extends HTMLElement {
            constructor() {
                super();

                this.cartInner = this.closest('.cart-drawer').querySelector('.drawer__inner');

                this.canvas = this.querySelector('canvas');
                this.ctx = this.canvas.getContext('2d');
                this.canvas.width = this.clientWidth;
                this.canvas.height = this.clientHeight;

                this.colors = [
                    "#10b981",
                    "#7c3aed",
                    "#fbbf24",
                    "#ef4444",
                    "#3b82f6",
                    "#22c55e",
                    "#f97316",
                    "#ef4444",
                ]
            }

            connectedCallback() {
                this.observer = new MutationObserver(this.onCartUpdated.bind(this));
                this.observer.observe(
                    this.cartInner,
                    { childList: true }
                );
            }

            disconnectedCallback() {
                this.observer.disconnect();
            }

            renderWrappingConfetti() {
                const timeDelta = 0.05;
                const xAmplitude = 0.5;
                const yAmplitude = 1;
                const xVelocity = 10;
                const yVelocity = 15;

                let time = 0;
                const confetti = []

                for (let i = 0; i < 100; i++) {
                    const radius = Math.floor(Math.random() * 50) - 10
                    const tilt = Math.floor(Math.random() * 10) - 10
                    const xSpeed = Math.random() * xVelocity - xVelocity / 2
                    const ySpeed = Math.random() * yVelocity
                    const x = Math.random() * this.canvas.width;
                    const y = Math.random() * this.canvas.height - this.canvas.height;

                    confetti.push({
                        x,
                        y,
                        xSpeed,
                        ySpeed,
                        radius,
                        tilt,
                        color: this.colors[Math.floor(Math.random() * this.colors.length)],
                        phaseOffset: i, // Randomness from position in list
                    })
                }

                const update = () => {
                    this.ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);
                    confetti.forEach((piece, i) => {
                        piece.y += (Math.cos(piece.phaseOffset + time) + 1) * yAmplitude + piece.ySpeed;
                        piece.x += Math.sin(piece.phaseOffset + time) * xAmplitude + piece.xSpeed;
                        // Wrap around the this.canvas
                        // if (piece.x < 0) piece.x = this.canvas.width;
                        // if (piece.x > this.canvas.width) piece.x = 0;
                        // if (piece.y > this.canvas.height) piece.y = 0;

                        this.ctx.beginPath();
                        this.ctx.lineWidth = piece.radius / 2;
                        this.ctx.strokeStyle = piece.color;
                        this.ctx.moveTo(piece.x + piece.tilt + piece.radius / 4, piece.y);
                        this.ctx.lineTo(piece.x + piece.tilt, piece.y + piece.tilt + piece.radius / 4);
                        this.ctx.stroke();
                    })
                    time += timeDelta;

                    requestAnimationFrame(update);
                }

                update();
            }

            onCartUpdated() {
                const goals = this.cartInner.querySelectorAll('.cart-upsell__line_goal');
                let animationShowed = false;

                goals.forEach((goal) => {
                    const goalType = goal.getAttribute('data-goal-type'),
                          isGoalShowed = sessionStorage.getItem('CartGoal-' + goalType + '-showed') === 'true';

                    if (goal.classList.contains('active')) {
                        if (!isGoalShowed && !animationShowed) {
                            this.renderWrappingConfetti();
                            animationShowed = true;
                        }

                        sessionStorage.setItem('CartGoal-' + goalType + '-showed', 'true');
                    } else {
                        sessionStorage.setItem('CartGoal-' + goalType + '-showed', 'false');
                    }
                })
            }
        }
    );
}
